(function ($) {

    // =========================================
    // Page Popup
    // =========================================

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, days) {
        var expires = '';
        if (days > 0) {
            var d = new Date();
            d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + d.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
    }

    function showPopup($popup) {
        $popup.removeAttr('hidden').addClass('is-visible');
        if ($popup.hasClass('oe-popup--center')) {
            $('body').css('overflow', 'hidden');
        }
    }

    function closePopup($popup, cookieKey, cookieDays) {
        $popup.removeClass('is-visible');
        $('body').css('overflow', '');
        if (cookieDays > 0) {
            setCookie(cookieKey, '1', cookieDays);
        }
        setTimeout(function () {
            $popup.attr('hidden', '');
        }, 300);
    }

    $(function () {
        var $popup = $('#oe-popup');
        if (!$popup.length) return;

        var cookieKey = $popup.data('cookie-key');
        var cookieDays = parseInt($popup.data('cookie-days'), 10);
        var delayMs = parseInt($popup.data('delay'), 10);

        if (getCookie(cookieKey)) return;

        setTimeout(function () {
            showPopup($popup);
        }, delayMs);

        $popup.on('click', '.oe-popup-close', function () {
            closePopup($popup, cookieKey, cookieDays);
        });

        $popup.on('click', '.oe-popup-overlay', function () {
            closePopup($popup, cookieKey, cookieDays);
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $popup.hasClass('is-visible')) {
                closePopup($popup, cookieKey, cookieDays);
            }
        });
    });

})(jQuery);
